<div>
  <div class="loader">
    <mat-spinner *ngIf="dataLoading" diameter="30"></mat-spinner>
  </div>
  <div>
    <h1 mat-dialog-title>{{'module-assignment.hotkeys.add_details' | translate}}</h1>
    <div id="divDialogContent" mat-dialog-content [formGroup]="frmHotKey">
      <div
        fxLayout="row wrap"
        fxLayoutGap="20px grid"
        class="u-margin-top-15 u-margin-bottom-15"
        *ngIf="action === 'Create'"
      >
        <div fxFlex="20">
          <p>
            {{ "module-assignment.hotkeys.search_by" | translate }}
          </p>
        </div>
        <div fxFlex="30">
          <mat-form-field floatLabel="never">
            <input
              type="text"
              matInput
              formControlName="filterBySkuCtrl"
              [matAutocomplete]="autoSku"
              [placeholder]="'module-assignment.hotkeys.sku' | translate"
              (keyup)="onSearchInput($event)"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #autoSku="matAutocomplete"
              (optionSelected)="onSelectProduct($event)"
              [displayWith]="displaySku"
            >
              <mat-option disabled class="loading" *ngIf="searching">
                <div class="image-container">
                  <mat-spinner diameter="30"></mat-spinner>
                </div>
              </mat-option>
              <mat-option *ngFor="let option of options" [value]="option">
                {{option.SKU}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div fxFlex="10">
          <p>
            {{ "module-assignment.hotkeys.or" | translate }}
          </p>
        </div>
        <div fxFlex="30">
          <mat-form-field floatLabel="never">
            <input
              type="text"
              matInput
              formControlName="filterByNameCtrl"
              [matAutocomplete]="autoProduct"
              [placeholder]="'module-assignment.hotkeys.product_name' | translate"
              (keyup)="onSearchInput($event)"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #autoProduct="matAutocomplete"
              (optionSelected)="onSelectProduct($event)"
              [displayWith]="displayProductName"
            >
              <mat-option disabled class="loading" *ngIf="searching || !options.length">
                <div class="image-container">
                  <mat-spinner diameter="30"></mat-spinner>
                </div>
              </mat-option>
              <mat-option *ngFor="let option of options" [value]="option">
                {{option.description}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid" class="u-margin-top-15 u-margin-bottom-15">
        <div fxFlex="60">
          <!-- <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="30">
          <p>
            {{ "module-assignment.hotkeys.position" | translate }}
          </p>
        </div>
        <div fxFlex="70">
          <mat-form-field class="mat-block" floatLabel="never">
            <input matInput formControlName="position" type="number" />
          </mat-form-field>
        </div>
      </div> -->
          <div fxLayout="row wrap" fxLayoutGap="20px grid">
            <div fxFlex="30">
              <p>
                {{ "module-assignment.hotkeys.displayName" | translate }}
              </p>
            </div>
            <div fxFlex="70">
              <mat-form-field class="mat-block" floatLabel="never">
                <input matInput formControlName="displayName" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="20px grid">
            <div fxFlex="30">
              <p>
                {{ "module-assignment.hotkeys.sku" | translate }}
              </p>
            </div>
            <div fxFlex="70">
              <mat-form-field class="mat-block" floatLabel="never">
                <input matInput formControlName="sku" />
              </mat-form-field>
            </div>
          </div>
          <div fxLayout="row wrap" fxLayoutGap="20px grid" *ngIf="frmHotKey.get('sku').value">
            <div fxFlex="30">
              <p>
                {{ "module-assignment.hotkeys.add_thumbnail" | translate }}
              </p>
            </div>
            <div fxFlex="70">
              <button
                type="button"
                mat-raised-button
                (click)="fileInput.click()"
                [disabled]="action==='view'"
              >
                Choose File
              </button>
              <input hidden (change)="onFileChange($event)" #fileInput type="file" />
            </div>
            <div class="u-text-left">
              <!-- <p>
                <b>
                  {{'module-assignment.hotkeys.note' | translate}}
                </b>
              </p> -->
              <p class="list">
                <b>
                  {{'module-assignment.hotkeys.size_note' | translate}}
                </b>
              </p>
              <p class="list">
                <b>
                  {{'module-assignment.hotkeys.ratio_note' | translate}}
                </b>
              </p>
            </div>
          </div>
        </div>
        <div fxFlex="40" class="image-container">
          <div *ngIf="frmHotKey.get('image').value" class="image-box">
            <img id="product-image" [src]="frmHotKey.get('image').value" class="product-image" />
          </div>
        </div>
      </div>
    </div>
    <div id="divDialogAction" mat-dialog-actions class="pull-right">
      <button
        id="btnYes"
        mat-flat-button
        mat-dialog-close="yes"
        cdkFocusInitial
        color="primary"
        [disabled]="frmHotKey.invalid || !frmHotKey.get('sku').value || dataLoading || action==='view'"
        (click)="onSave()"
      >
        {{'module-assignment.hotkeys.ok' | translate}}
      </button>
      <button id="btnNo" mat-flat-button mat-dialog-close="no" color="warn" (click)="onCancel()">
        {{'module-assignment.hotkeys.cancel' | translate}}
      </button>
    </div>
  </div>
</div>
